import {apiClient, queryClient} from '@common/http/query-client';
import {useQuery} from '@tanstack/react-query';
import {PolicyFailReason} from '@common/billing/upgrade/policy-fail-reason';

interface ResourceStatus {
  allowed: boolean;
  failReason?: PolicyFailReason;
}

interface ResourceTeam {
  name: string;
  total_member: number;
  owner_id: number;
  owner_name: string;
}


interface Response {
  team: {
    id: number;
    name: string;
    members_count: number;
    owner_id: number;
    team_member_id: number;
    owner_name: string;
  }
  
}

export function useMyTeam() {
  return useQuery({
    queryKey: ['my-team'],
    queryFn: () => fetchMyTeam(),
  });
}

export function reloadMyTeam() {
  return queryClient.invalidateQueries({
    queryKey: ['my-team'],
  });
}

function fetchMyTeam() {
  return apiClient
    .get<Response>(`my-team`)
    .then(response => response.data);
}
